import React from 'react';

import { Modal } from '@atom/mui';
import colors from '@atom/styles/colors';

export interface Props {
  open: boolean;
  loading?: boolean;
  title?: string;
  content?: React.ReactNode;
  cancelText?: string;
  confirmText?: string;
  onCancel: () => void;
  onConfirm: () => void;
  onExited?: () => void;
  disabled?: boolean;
  dataCy?: string;
}

const styles = {
  content: {
    minHeight: '3rem',
  },
};

const DeleteModal = ({
  open,
  loading,
  title = 'Delete?',
  content,
  onCancel,
  onConfirm,
  onExited,
  cancelText = 'Cancel',
  confirmText = 'Delete',
  disabled = false,
  dataCy = 'deleteModal',
}: Props) => {
  return (
    <Modal
      open={open}
      title={title}
      loading={loading}
      onConfirm={onConfirm}
      onCancel={onCancel}
      onExited={onExited}
      disabled={disabled}
      confirmButtonText={confirmText}
      cancelButtonText={cancelText}
      contentStyle={styles.content}
      data-cy={dataCy}
      CancelButtonProps={{ ['data-cy']: `${dataCy}CancelButton` }}
      ConfirmButtonProps={{
        sx: {
          ...(!loading && {
            background: colors.brand.red,
            color: colors.neutral.white,
          }),
        },
        ['data-cy']: `${dataCy}ConfirmButton`,
      }}
    >
      {content}
    </Modal>
  );
};

export default DeleteModal;
